import { render } from "./BasicModal.vue?vue&type=template&id=00e64290&scoped=true&ts=true"
import script from "./BasicModal.vue?vue&type=script&lang=ts"
export * from "./BasicModal.vue?vue&type=script&lang=ts"

import "./BasicModal.vue?vue&type=style&index=0&id=00e64290&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e64290"]])

export default __exports__